import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordForm } from '@web/modules/auth/forgot-password-form';

export const Route = createFileRoute('/_auth/forgot-password')({
  component: ForgotPasswordForm,
});
